import { Container, Typography } from '@cleartrip/ct-design-components'
import { FC } from 'react'

import WowBadge from '@/components/wowPricingComponents/WowBadge'
import { MESSAGE_SPLIT_PATTERN, WOW_LABEL_GRADIENT } from '@/constants/Srp'
import { formatCurrency } from '@/utils'

export interface WowFareCalloutProps {
  couponCallout: string
  wowApplicable: boolean
  wowDisplayPrice: number
  isIntl?: boolean
  isSrpRevamp?: boolean
  className?: string
  labelStyle?: React.CSSProperties
  style?: React.CSSProperties
}

const WowFareCallout: FC<WowFareCalloutProps> = ({
  couponCallout,
  wowApplicable = false,
  wowDisplayPrice,
  isIntl = false,
  isSrpRevamp = false,
  className = '',
  labelStyle: customLabelStyle,
  style: customStyle,
}) => {
  const labelClassName = !isSrpRevamp && wowApplicable ? 'py-1 px-2 br-12' : ''
  const defaultLabelStyle = wowApplicable && !isSrpRevamp ? { background: WOW_LABEL_GRADIENT } : undefined
  const labelStyle = customLabelStyle ? { ...defaultLabelStyle, ...customLabelStyle } : defaultLabelStyle

  if (!couponCallout) {
    return null
  }

  return (
    <Container
      className={`flex flex-end flex-middle ${className}`}
      style={{ marginTop: isSrpRevamp ? 0 : isIntl ? '6px' : '0px', ...customStyle }}
    >
      <Typography className={labelClassName} color='success' style={labelStyle} variant='B3'>
        {couponCallout.split(MESSAGE_SPLIT_PATTERN).map((part: string, idx: number) => {
          if (part && part.match(/^({wow})$/i)) {
            return (
              <Container key={idx} className='flex flex-inline' position='relative' style={{ top: '2px' }}>
                <WowBadge />
              </Container>
            )
          }
          if (part && part.match(/^({wowDisplayPrice})$/i)) {
            return (
              <span key={idx} className={isSrpRevamp ? undefined : 'fw-700 fs-14 lh-20'}>
                {formatCurrency(wowDisplayPrice)}
              </span>
            )
          }
          if (part && part.match(/^<b>[^<]*<\/b>$/i)) {
            return <strong key={idx}>{part.replace(/<\/?b>/gi, '')}</strong>
          }
          return <span key={idx}>{part}</span>
        })}
      </Typography>
    </Container>
  )
}

export default WowFareCallout